import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      routineData: [],
      reference: null
    }
  },
  getters: {
    routineData (state) {
      return state.routineData
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.routineData = []
    },
    add (state, payload) {
      state.routineData.push(payload)
    },
    update (state, payload) {
      const index = state.routineData.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.routineData, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.routineData.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.routineData.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var user = this.getters['authUser/user']
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('routine_data').doc(user.key).collection('data')
        var reference = dbRef.orderBy('createdAt', 'desc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              owner: change.doc.data().owner,
              date: change.doc.data().date,
              dateText: change.doc.data().dateText,
              routineCounter: change.doc.data().routineCounter,
              routineService: change.doc.data().routineService,
              routineGroup: change.doc.data().routineGroup,
              routineUser: change.doc.data().routineUser,
              routineSelf: change.doc.data().routineSelf,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            if (change.type === 'added') {
              commit('add', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'modified') {
              commit('update', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'removed') {
              commit('remove', JSON.parse(JSON.stringify(payload)))
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['routineData/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/RoutineData.js